import type { SVGProps } from 'react';

/**
 * The noissue shooting star — the brand mark, not a decorative icon.
 *
 * IT LIVES HERE BECAUSE A MODULE NEEDS IT. The wordmark sits in the shell
 * (apps/web/src/shell/components/logo.tsx) because only host chrome draws it, and a module
 * has no business rendering the company's identity into its own page. This mark is the
 * other case: the Company Roadmap's North Star tile is a module surface that is
 * legitimately branded, and a module may import nothing but @noissue/os-ui — so the choice
 * was here or a copy inside every module that wants it. One canonical copy, same argument
 * as the rest of the kit.
 *
 * Drawn at the brand's own 67×27 proportions with `fill="currentColor"`, so it inherits
 * the surrounding text colour. Size it with a height and let the width follow
 * (`className="h-3.5 w-auto"`); forcing a square crops or distorts it.
 *
 * Decorative by default — `aria-hidden`, since it always sits beside a label that already
 * says "North Star". Pass `aria-hidden={false}` with a `role="img"` and a label if it ever
 * stands alone.
 */
export function NorthStarMark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 67 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M 8.539 18.185 C 5.806 20.791 3.073 23.423 0.314 26.028 C 0.21 26.135 0.106 26.214 0.028 26.347 C -0.076 26.533 0.132 26.799 0.34 26.719 C 0.548 26.666 0.757 26.56 0.939 26.507 C 4.739 25.071 8.513 23.635 12.314 22.2 C 14.006 23.768 15.698 25.337 17.39 26.906 C 17.52 27.065 17.78 27.012 17.858 26.826 C 18.925 24.22 19.993 21.562 21.06 18.93 C 36.287 16.377 51.541 13.852 66.768 11.299 C 67.054 11.273 67.08 10.874 66.82 10.741 C 66.638 10.714 66.43 10.741 66.247 10.741 C 52.217 10.741 38.161 10.741 24.131 10.741 C 25.381 7.311 26.63 3.882 27.88 0.452 C 27.958 0.293 27.88 0.107 27.723 0.027 C 27.541 -0.08 27.385 0.16 27.255 0.239 C 23.559 3.749 19.862 7.232 16.166 10.714 C 11.559 10.714 6.926 10.714 2.318 10.714 C 2.162 10.714 2.032 10.714 1.98 10.901 C 1.902 11.06 1.98 11.166 2.11 11.273 L 8.539 18.185 Z"
        fill="currentColor"
      />
    </svg>
  );
}
